import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "min-h-full" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = {
  role: "list",
  class: "grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
}
const _hoisted_4 = { class: "flex-1 flex flex-col p-8" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "mt-6 text-gray-500 text-sm font-medium" }

import Decedent from "@/models/Decedent";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";

import AppHeader from "@/components/AppHeader.vue";

// @Options({
//   components: {
//     AppHeader,
//   },
// })
// export default class MyDecedentsView extends Vue {

export default /*#__PURE__*/_defineComponent({
  __name: 'MyDecedentsView',
  setup(__props) {

// import { Options, Vue } from "vue-class-component";
// import Decedent from "../models/Decedent";

const store = useStore();

const decedents = ref<Decedent[]>([]);

const refresh = () => {
  store.dispatch("setLoading", true);
  setTimeout(async () => {
    if (!store.state.customer) {
      return;
    }
    try {
      decedents.value = await Decedent.getMyDecedents(store.state.customer!.id);
    } finally {
      store.dispatch("setLoading", true);
    }
  });
};

onMounted(() => {
  refresh();
});

// }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(decedents.value, (decedent) => {
            return (_openBlock(), _createElementBlock("li", {
              key: decedent.id,
              class: "col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200"
            }, [
              _createVNode(_component_router_link, {
                to: `/decedents/${decedent.id}`
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                      class: "w-32 h-32 flex-shrink-0 mx-auto rounded-full",
                      src: 
                  decedent.selfie_image_url ??
                  require('@/assets/images/no-selfie.png')
                ,
                      alt: ""
                    }, null, 8, _hoisted_5),
                    _createElementVNode("h3", _hoisted_6, _toDisplayString(decedent.display_name), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})